/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import genericChartVisualizationReducer from './genericChartVisualizationReducer';
import { IState } from '../../../../store/types/StateTypes';

export default function timeSeriesChartVisualizationStaticPropertiesReducer(staticProperties :any, state: IState, action :any) {

    // Time series visualization require the first field in Rows to be expanded
    // When user changes visualization from, let's say, column to time series, it may happen
    // that the first field stay collapsed, which produces wrong results for time series.
    // moreover, the server's logic is the same: it expands first field.
    // Btw, time series charts accept only one field in Rows.

    const newStaticProperties = genericChartVisualizationReducer(staticProperties, state, action);

    if (newStaticProperties.onyx3ChartRows && newStaticProperties.onyx3ChartRows.length) {
        let metFirstField = false;
        newStaticProperties.onyx3ChartRows.forEach((item :any) => {
            if (item.measuresLevel) {
                return;
            }
            if (metFirstField) {
                return;
            }
            metFirstField = true;
            if (item.expanded === false) {
                /* eslint-disable no-param-reassign */
                item.expanded = true;
            }
        });
    }

    return newStaticProperties;
}
